<header class="header-logo">
    <button
        class="logo"
        attr.aria-label="{{ 'headerLogo.label' | translate }}"
        (click)="redirectPage()">
    </button>
</header>
